import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Calculator, Pencil } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "./Logo";

const links = [
  { to: "/villes", label: "Villes" },
  { to: "/devis", label: "Comparer" },
  { to: "/qui-sommes-nous", label: "Qui sommes-nous" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="glass-header fixed top-0 inset-x-0 z-50 border-b border-border/60" data-testid="site-header">
      <div className="mx-auto w-full max-w-[1440px] px-5 md:px-8 flex items-center justify-between gap-4 py-4">
        <Logo />

        <nav className="hidden xl:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm font-bold px-3.5 py-2 rounded-full whitespace-nowrap transition-colors ${
                  isActive ? "text-[hsl(var(--ocean))] bg-[hsl(var(--ocean))]/10" : "text-foreground hover:text-[hsl(var(--ocean))] hover:bg-secondary"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink to="/simulateur" className="ml-1 btn-sun py-2 px-4 whitespace-nowrap" data-testid="nav-simulateur"><Calculator size={14} /> Faites estimer !</NavLink>
        </nav>

        <div className="hidden xl:block">
          <button onClick={() => navigate("/devis")} className="btn-accent whitespace-nowrap" data-testid="header-cta-devis">
            <Pencil size={14} /> Je demande un devis
          </button>
        </div>

        <button
          className="xl:hidden p-2 rounded-full bg-white border border-border"
          aria-label="menu"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="xl:hidden border-t border-border/60 bg-background"
            data-testid="mobile-menu"
          >
            <div className="container-tm py-6 flex flex-col gap-4">
              {[...links, { to: "/simulateur", label: "Simulateur de revenus" }].map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="text-base font-medium py-2"
                  data-testid={`mobile-nav-${l.to.replace("/", "")}`}
                >
                  {l.label}
                </NavLink>
              ))}
              <button
                onClick={() => {
                  setOpen(false);
                  navigate("/devis");
                }}
                className="btn-accent justify-center mt-2"
                data-testid="mobile-cta-devis"
              >
                Demander un devis gratuit
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
